import { createFeatureSelector, createSelector } from '@ngrx/store';
import { renalDetectFeatureKey } from '../renal-detect-feature-key';
import { RenalDetectState } from '../renal-detect.state';

const selectState = createFeatureSelector<RenalDetectState>(renalDetectFeatureKey);
/**
 * Select forms values
 */
export const selectDetection = createSelector(selectState, (state) => state.detection);
export const selectChoice = createSelector(selectState, (state) => state.nutritionRecommendationChoice);
export const selectRecommendation = createSelector(selectState, (state) => state.recommendation);
